export const identify = (id, params) => {
  if (window.analytics) {
    window.analytics.identify(id, params)
  }
}

export const track = (event, params) => {
  if (window.analytics) {
    window.analytics.track(event, params)
  }
  if (window.fbq) {
    window.fbq('track', event, params)
  }
}

export const trackPage = () => {
  if (window.analytics) {
    window.analytics.page()
  }
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}
